import { createFileRoute } from '@tanstack/react-router'

import { buildPageTitle } from '@/shared/lib/page-title'
import { GroupsListPage } from '@/features/groups'

export const Route = createFileRoute('/_authenticated/_main/grupos/')({
  head: () => ({
    meta: [{ title: buildPageTitle('Grupos') }]
  }),
  component: GroupsListPage
})
